import { createAction, props } from '@ngrx/store';
import { ConfirmFormData } from 'src/app/models/confirm-data/confirm-form-data.model';
import { DeliveryCourierFormData } from 'src/app/models/delivery-courier/delivery-courier-form-data.model';
import { DeliveryPointFormData } from 'src/app/models/delivery-courier/delivery-point-form-data.model';
import { ShipmentFormData } from 'src/app/models/shipment/shipment-form-data.model';
import { ShippingCourierFormData } from 'src/app/models/shipping-courier/shipping-courier-form-data.model';
import { ShippingPointFormData } from 'src/app/models/shipping-courier/shipping-point-form-data.model';

export const changeShippingCourierFormData = createAction(
  '[FormsData] Change shippingCourierFormData',
  props<{ shippingCourierFormData: ShippingCourierFormData | undefined }>()
);

export const changeShippingPointFormData = createAction(
  '[FormsData] Change shippingPointFormData',
  props<{ shippingPointFormData: ShippingPointFormData | undefined }>()
);

export const changeShipmentFormData = createAction(
  '[FormsData] Change shipmentFormData',
  props<{ shipmentFormData: ShipmentFormData | undefined }>()
);

export const changeDeliveryCourierFormData = createAction(
  '[FormsData] Change deliveryCourierFormData',
  props<{ deliveryCourierFormData: DeliveryCourierFormData | undefined }>()
);

export const changeDeliveryPointFormData = createAction(
  '[FormsData] Change deliveryPointFormData',
  props<{ deliveryPointFormData: DeliveryPointFormData | undefined }>()
);

export const changeConfirmFormData = createAction(
  '[FormsData] Change confirmFormData',
  props<{ confirmFormData: ConfirmFormData | undefined }>()
);

export const changeSelectedPartners = createAction(
  '[FormsData] Change selectedPartners',
  props<{ selectedPartners: string[] }>()
);
